






export default 
	name: "Snackbar"
	
	props: ['message']
	
	watch:
		'message': (msg) ->
			@$el.MaterialSnackbar.showSnackbar
				message: @message




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/elements/Snackbar.vue